import { render } from "./Notices.vue?vue&type=template&id=1bea914e&scoped=true"
import script from "./Notices.vue?vue&type=script&lang=js"
export * from "./Notices.vue?vue&type=script&lang=js"

import "./Notices.vue?vue&type=style&index=0&id=1bea914e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bea914e"]])

export default __exports__